export default __webpack_public_path__ + "static/media/optimization.690c3f32.png";